/**
 * Tiny cross-platform key/value store for small UI preferences.
 * - web: localStorage (synchronous, wrapped in a promise)
 * - native: expo-secure-store
 *
 * Not for large data — preferences only (e.g. the selected palette key).
 */
import { Platform } from 'react-native'
import * as SecureStore from 'expo-secure-store'

export async function getItem(key: string): Promise<string | null> {
  try {
    if (Platform.OS === 'web') {
      return globalThis.localStorage?.getItem(key) ?? null
    }
    return await SecureStore.getItemAsync(key)
  } catch {
    return null
  }
}

export async function setItem(key: string, value: string): Promise<void> {
  try {
    if (Platform.OS === 'web') {
      globalThis.localStorage?.setItem(key, value)
      return
    }
    await SecureStore.setItemAsync(key, value)
  } catch {
    // best-effort; a failed pref write should never crash the app
  }
}
